import { render, staticRenderFns } from "./ColorRatioItem.vue?vue&type=template&id=04fb85c8&scoped=true"
import script from "./ColorRatioItem.vue?vue&type=script&lang=js"
export * from "./ColorRatioItem.vue?vue&type=script&lang=js"
import style0 from "./ColorRatioItem.vue?vue&type=style&index=0&id=04fb85c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fb85c8",
  null
  
)

export default component.exports